import React, { useState } from 'react'
import Breadcrumb from 'src/Components/HelpCenter/Breadcrumb'
// import Logo from '../../Common/Icon/CtdFullLogo.svg'
import ResolvedTopics from 'src/Components/HelpCenter/ResolvedTopics'
import { IoMdClose } from 'react-icons/io'
import { useHelpCenterStore } from 'src/Containers/HelpCenter/helpCenterStore'

const QuestionPage = () => {
    const selectedQuestion = useHelpCenterStore((state) => state.selectedQuestion)

    // Default values if no question is selected
    const questionTitle = selectedQuestion?.title || 'Unknown Question'
    const questionContent = selectedQuestion?.content || 'No description available.'

    console.log(selectedQuestion, 'selectedQuestion')
    console.log(questionTitle, 'questionTitle')
    console.log(questionContent, 'questionContent')

    const [ feedback, setFeedback ] = useState(null) // 'yes' | 'no' | null
    const [ selectedRating, setSelectedRating ] = useState(null)
    const [ submitted, setSubmitted ] = useState(false)
    const [ showDrawer, setShowDrawer ] = useState(false)
    const [ feedbackText, setFeedbackText ] = useState('')
    const [ error, setError ] = useState('')

    // Emoji options with response messages
    const emojis = [
        { id: 1, emoji: '😠', label: 'Very Dissatisfied', response: "We're really sorry! Let’s fix this immediately." },
        { id: 2, emoji: '☹️', label: 'Dissatisfied', response: 'We understand this is frustrating. Tell us more.' },
        { id: 3, emoji: '😐', label: 'Neutralks', response: "Got it! We'll improve." },
        { id: 4, emoji: '🙂', label: 'Satisfied', response: "We're happy to hear that it was successful!" },
        { id: 5, emoji: '😃', label: 'Very Satisfied', response: 'Awesome! Happy to have helped!' }
    ]

    const handleSelect = (id) => {
        setSelectedRating(id)
    }

    const handleSubmit = () => {
        if (selectedRating !== null) {
            setSubmitted(true)
        }
    }

    const openDrawer = () => {
        setShowDrawer(true)
    }

    const closeDrawer = () => {
        setShowDrawer(false)
        setFeedbackText('')
        setError('')
    }

    const handleFeedbackSubmit = () => {
        if (feedbackText.trim() === '') {
            setError('Feedback is required.')
            return
        }
        alert(`Feedback Submitted: ${feedbackText}`)
        closeDrawer()
    }

    return (
        <div className='text-primary bg-[#fff] h-fit'>
            <Breadcrumb />
            <div className='grid grid-cols-[1.5fr_1fr] gap-4 p-4'>
                <div className='justify-self-stretch'>
                    <div className="p-8 border rounded-md w-full mx-8 my-6">
                        <h2 className="text-2xl font-semibold mb-6 capitalize">{questionTitle}</h2>
                        {questionContent?.length
                            ? (
                                questionContent?.map((item, index) => {
                                    if (item.type === 'heading') {
                                        return <h3 key={index} className="text-xl font-semibold mb-2">{item.text}</h3>
                                    } else if (item.type === 'paragraph') {
                                        return <p key={index} className="text-[#333] text-lg mb-4">{item.text}</p>
                                    } else if (item.type === 'list') {
                                        return (
                                            <ul key={index} className={`ml-6 text-lg mb-4 !text-primary ${item.format === 'ordered' ? 'list-decimal' : 'list-disc'}`}>
                                                {item.items.map((listItem, i) => (
                                                    <li key={i} className="mb-1 text-[#333]">
                                                        {listItem.title && <span className='inline text-primary font-medium'>{listItem.title}</span>}
                                                        {listItem.text && <span className='inline text-[#333] ml-1'>{listItem.text}</span>}

                                                        {/* Render sub-items if available */}
                                                        {listItem?.sub_items?.length > 0 && (
                                                            <ul className="list-disc ml-6">
                                                                {listItem.sub_items.map((subItem, subIndex) => (
                                                                    <li key={subIndex} className="text-md text-gray-500">
                                                                        {subItem?.title && <span className='inline text-primary font-medium'>{subItem?.title}</span>}
                                                                        {subItem?.text && <span className='inline text-[#333] ml-1'>{subItem?.text}</span>}
                                                                        {/* Render deeper nested lists if available */}
                                                                        {subItem?.items?.length > 0 && (
                                                                            <ul className={`ml-6 ${subItem.format === 'ordered' ? 'list-decimal' : 'list-disc'}`}>
                                                                                {subItem.items.map((nestedItem, nestedIndex) => (
                                                                                    <li key={nestedIndex} className="text-md text-gray-500">{nestedItem.text}</li>
                                                                                ))}
                                                                            </ul>
                                                                        )}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )
                                    } else if (item.type === 'image') {
                                        return (
                                            <div key={index} className="my-4">
                                                <img src={item.url} alt={item.description} className="w-full rounded-md" />
                                                <p className="text-sm text-gray-500 text-center">{item.description}</p>
                                            </div>
                                        )
                                    } else if (item.type === 'table') {
                                        return (
                                            <div key={index} className="my-4 overflow-auto">
                                                <h3 className="text-xl font-semibold mb-8">{item.title}</h3>
                                                {item.sections.map((section, secIndex) => (
                                                    <div key={secIndex} className="mb-4">
                                                        <h4 className="text-lg font-bold mb-2">{section.heading}</h4>
                                                        <table className="w-full mb-10 border border-gray-300 text-left">
                                                            <thead>
                                                                <tr>
                                                                    {section.columns.map((col, colIndex) => (
                                                                        <th key={colIndex} className="border px-4 py-2 bg-gray-100">{col}</th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {section.rows.map((row, rowIndex) => (
                                                                    <tr key={rowIndex} className='text-[#333]'>
                                                                        {row.map((cell, cellIndex) => (
                                                                            <td key={cellIndex} className="border px-4 py-2">{cell}</td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    }
                                    return null
                                })
                            )
                            : (
                                <p className="text-grcColor">No content available.</p>
                            )}
                    </div>
                    <div className="p-8 border rounded-md w-3/5 mx-8 my-6 opacity-50 pointer-events-none">
                        {feedback === null
                            ? (
                                <>
                                    <h2 className="text-xl font-semibold mb-6">Was this information helpful?</h2>
                                    <div className="flex gap-4">
                                        <button className="text-md font-medium bg-primary text-[#fff] py-2 px-10 rounded-md" onClick={() => setFeedback('yes')}>Yes</button>
                                        <button className="text-md font-medium border border-grey hover:border-primary hover:bg-primary-foreground hover:text-primary text-grey py-2 px-10 rounded-md transition-all" onClick={() => setFeedback('no')}>No</button>
                                    </div>
                                </>
                            )
                            : feedback === 'no'
                                ? (
                                    <div>
                                        <p className="text-lg font-semibold ">Please share your feedback on why it didn&apos;t work.</p>
                                        <button onClick={openDrawer} className="text-primary text-sm mt-4 underline cursor-pointer hover:font-medium transition-all">Submit Feedback</button>
                                    </div>
                                )
                                : submitted
                                    ? (
                                        <div className='flex flex-col items-center'>
                                            <p className="text-4xl scale-125">{emojis.find(e => e.id === selectedRating)?.emoji}</p>
                                            <p className="text-lg font-semibold mt-4">{emojis.find(e => e.id === selectedRating)?.response}</p>
                                            {selectedRating <= 2 && (
                                                <button onClick={openDrawer} className="text-primary text-sm mt-1 underline cursor-pointer hover:font-medium transition-all">Submit Feedback</button>
                                            )}
                                        </div>
                                    )
                                    : (
                                        <>
                                            <h2 className="text-xl font-semibold mb-6">How satisfied are you with our help center?</h2>
                                            <div className="flex space-x-3 mb-4">
                                                {emojis.map((item) => (
                                                    <button
                                                        key={item.id}
                                                        onClick={() => handleSelect(item.id)}
                                                        className={`text-4xl transition-all duration-200 ${selectedRating === item.id ? 'scale-125 filter-none' : 'grayscale hover:grayscale-0 opacity-80 hover:opacity-100 hover:scale-110'}`}
                                                        aria-label={item.label}
                                                    >
                                                        {item.emoji}
                                                    </button>
                                                ))}
                                                <button
                                                    onClick={handleSubmit}
                                                    className="bg-primary text-[#fff] !ml-8 block px-4 py-2 rounded-md hover:bg-teal-800 transition-all"
                                                    disabled={selectedRating === null}
                                                >
                                                Submit
                                                </button>
                                            </div>
                                        </>
                                    )}
                    </div>
                </div>
                <div className='justify-self-center mx-32 my-4'>
                    <ResolvedTopics disabled={true} />
                </div>
            </div>

            {/* ✅ Side Drawer for Feedback */}
            {showDrawer && (
                <div className="fixed top-0 right-0 h-full w-[30%] bg-white shadow-lg border-l flex flex-col bg-[#fff] z-[31]">
                    {/* Drawer Header */}
                    <div className="p-6 flex justify-between items-center border-b">
                        <h2 className="text-xl font-semibold">Submit Feedback</h2>
                        <button onClick={closeDrawer} className="text-gray-500 hover:text-black">
                            <IoMdClose className="text-2xl" />
                        </button>
                    </div>

                    {/* Feedback Input */}
                    <div className="mt-4 p-6 relative">
                        <label htmlFor="feedbackText" className="block text-xl font-medium text-[#333]">
                            Your Feedback
                        </label>
                        <textarea
                            id="feedbackText"
                            value={feedbackText}
                            onChange={(e) => {
                                if (e.target.value.length <= 250) {
                                    setFeedbackText(e.target.value)
                                    setError('')
                                }
                            }}
                            className="mt-4 ml-0 p-2 pb-4 w-full border rounded-md"
                            rows="4"
                            maxLength={250}
                        ></textarea>
                        <p className="text-xs bg-[#fff] text-grey absolute right-8 bottom-9">{feedbackText.length}/250</p>
                        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
                    </div>

                    {/* Drawer Footer Buttons */}
                    <div className="mt-auto flex gap-4 p-6 border-t justify-end">
                        <button onClick={closeDrawer} className="border px-4 py-2 rounded-md hover:bg-gray-100">
                            Cancel
                        </button>
                        <button onClick={handleFeedbackSubmit} className="bg-primary text-[#fff] px-4 py-2 rounded-md hover:bg-teal-800 transition-all">
                            Submit
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default QuestionPage
